<template name="component-name">
  <v-dialog v-model="show" max-width="800" retain-focus scrollable>
    <v-card>
      <v-card-title>
        <ADialogTitle :title="formTitle" @close="show = false"></ADialogTitle>
        <v-container class="pa-0 ma-0 ml-2 mr-2" v-if="alert && alert.length > 0">
          <v-row class="no-gutter align-center">
            <v-col>
              <v-alert text :color="alertType">{{alert}}</v-alert>
            </v-col>
          </v-row>
        </v-container>
      </v-card-title>
      <v-card-text>
        <v-form @submit.prevent="submit" ref="form">
          <input type="submit" class="d-none" />
          <v-container>
            <v-row class="justify-start align-center">
              <v-col
                class="col-12 col-sm-6"
                v-for="field in fieldsReady"
                :key="field.firstName"
                v-if="!field.hidden && !field.silent"
              >
                <v-text-field
                  :type="field.type"
                  v-if="(field.type == 'text' || field.type == 'password')"
                  outlined
                  :label="field.label"
                  :rules="field.rules"
                  :disabled="field.disabled"
                  @change="onChange"
                  v-model="field.value"
                  :hint="field.hint"
                  :persistent-hint="field.hint? true: false"
                ></v-text-field>
                <v-textarea
                  :type="field.type"
                  v-if="field.type == 'textarea'"
                  outlined
                  :label="field.label"
                  :rules="field.rules || []"
                  :disabled="field.disabled"
                  @change="onChange"
                  v-model="field.value"
                ></v-textarea>
                <v-select
                  v-if="field.type == 'dropdown'"
                  :label="field.label"
                  :items="field.items"
                  :rules="field.rules"
                  :disabled="field.disabled"
                  @change="onChange"
                  v-model="field.value"
                  :multiple="field.multiple"
                  :clearable="field.nullable"
                  outlined
                ></v-select>
                <v-menu v-model="field.menu" v-if="field.type == 'datepicker'">
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-on="on"
                      v-model="field.value"
                      :label="field.label"
                      :rules="field.rules"
                      :disabled="field.disabled"
                      @change="onChange"                      
                      prepend-icon="event"    
                      readonly                  
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="field.value" @input="field.menu = false" @change="onChange"></v-date-picker>
                </v-menu>
                <v-checkbox
                  v-if="field.type=='checkbox'"
                  v-model="field.value"
                  :label="field.label"
                  :rules="field.rules"
                  :disabled="field.disabled"
                  @change="onChange"
                ></v-checkbox>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <AFormActions
          :loading="loading"
          :disableSumbit="!isChanged"
          :hideReset="updateMode"
          :submitText="updateMode? 'update': 'save'"
          @reset="reset"
          @submit="submit"
        ></AFormActions>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import _ from "lodash";
import axios from "../api/axios";
import loadDropdown from "../mixins/loadDropdown";
import snackbar from "../mixins/snackbar";
import alertMixin from "../mixins/alert";
import ADialogTitle from "../components/dialog/ADialogTitle";
import AFormActions from "../components/dialog/AFormActions";

export default {
  name: "AFormDialog",
  mixins: [loadDropdown, snackbar, alertMixin],
  props: ["fields", "modelName", "model", "updateOnlyChanged"],
  components: {
    ADialogTitle,
    AFormActions
  },
  data() {
    return {
      show: false,
      loading: false,
      updateMode: false,
      item: {},
      fieldsReady: [],
      isChanged: true
    };
  },
  watch: {
    updateMode: function() {
      this.fields.forEach(el => {
        if (this.updateMode) {
          if (el.hideOnUpdate) el.hidden = el.hideOnUpdate ? true : false;
          if (!el.updatable) el.disabled = true;
        } else {
          el.disabled = false;
          el.hidden = false;
        }
      });
    }
  },
  computed: {
    formTitle: function() {
      return (this.updateMode ? "Update " : "Create ") + this.modelName;
    }
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.fieldsReady = [];
      this.fields.forEach(el => {
        if (this.updateMode) {
          if (el.hideOnUpdate) return;
          if (!el.updatable) el.disabled = true;
        }
        el.value = el.value || undefined;
        if (el.type == "dropdown") {
          if (el.model) {
            el.items = [];
            this.loadDropdownItems(el.model, el.items);
          }
        }
        this.fieldsReady.push(el);
      });
    },
    open(item) {
      this.resetAlert();
      if (!!item) {
        this.isChanged = false;
        this.updateMode = true;
        this.item = item;
        this.fieldsReady.forEach(el => {
          if (_.has(item, el.queryParam)) {
            if (el.readValueFormatter) {
              el.originalValue = el.value = el.readValueFormatter(item[el.queryParam])
            } 
            else {
              el.originalValue = el.value = item[el.queryParam];
            }
          }
        });
      } else {
        this.updateMode = false;
        this.isChanged = true;
        this.item = {};
      }
      this.show = true;
      this.loading = false;
    },
    reset() {
      this.$refs.form.reset();
      this.resetAlert();
    },
    submit() {
      this.resetAlert();
      if (this.$refs.form.validate()) {
        if (this.isChanged) {
          this.loading = true;
          this.axiosMethod()(this.uri(), this.params()).then(r => {
            this.loading = false;
            this.setAlert(r.data);
            if (r.data.ok) this.$emit("modified");
          });
        } else {
          this.snackbarError("No changes to update");
        }
      } else {
        this.snackbarError("Some fields needs attention");
      }
    },
    uri() {
      return this.updateMode ? this.model + "/" + this.item.id : this.model;
    },
    axiosMethod() {
      return this.updateMode ? axios.put : axios.post;
    },
    params() {
      let param = {};
      this.fieldsReady.forEach(el => {
        if (el.disabled || el.type == "silent") return;
        // TODO filter only changed fields as default for update and create modes
        if ((this.updateMode && this.updateOnlyChanged &&  !_.isEqual(el.originalValue, el.value)) ||  (this.updateMode && !this.updateOnlyChanged) ||  !this.updateMode ) {
          param[el.queryParam] = this.getFieldValue(el);
        }
      });
      this.fieldsReady.forEach(el => {
        if (el.type == "silent") {
          param[el.queryParam] = param[el.copyValueFrom] ? param[el.copyValueFrom] : el.defaultValue;
        }
      });
      return param;
    },
    getFieldValue(el) {
      console.log(el)
      if (el.valueFormatter) {
        return el.valueFormatter(el.value);
      } else {
        if(el.value) {
          return el.value.id || el.value;
        } else if (el.nullable) {
          return null;
        }
      }
    },
    hasValuesChanged() {
      if (this.updateMode) {
        let changed = false;
        this.fieldsReady.forEach(el => {
          if (el.updatable) {
            changed = changed || !_.isEqual(el.originalValue, el.value);
          }
        });
        return changed;
      }
      return true;
    },
    onChange() {
      this.isChanged = this.hasValuesChanged();
    }
  }
};
</script>